import React from 'react'
import { BooleanInput, BooleanInputProps } from 'react-admin'
import { useFormContext } from 'react-hook-form'

type Props = Omit<BooleanInputProps, 'options'> & {
  dependentFieldsSources: string[]
}

/**
 * Boolean Input which allows only one field to be true at a time, setting to false the other specified dependent fields.
 *
 * @param dependentFieldsSources: array of sources that are dependent on the value of the input, if this gets set to true, then every other dependent field will be set to false
 */
const ExclusiveBoolean: React.FC<Props> = ({
  source,
  dependentFieldsSources,
  onChange,
  ...rest
}) => {
  const { setValue } = useFormContext()

  const internalOnChange = (_event: any, e: boolean) => {
    if (onChange) onChange(_event, e)
    // Turning off the dependent fields
    dependentFieldsSources.forEach((source) => {
      setValue(source, false)
    })
    setValue(source, e)
  }
  return <BooleanInput {...rest} source={source} onChange={internalOnChange} />
}

export default ExclusiveBoolean
